import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { useNavigate } from 'react-router-dom';

const FlowChartPage = () => {
  const svgRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const width = 800;
    const height = 600;

    const nodes = [
      { id: 'camera1', label: 'Camera 1', x: 100, y: 100 },
      { id: 'camera2', label: 'Camera 2', x: 100, y: 200 },
      { id: 'camera3', label: 'Camera 3', x: 100, y: 300 },
      { id: 'collector', label: 'Collector', x: 300, y: 200 },
      { id: 'vision1', label: 'Vision Model 1', x: 500, y: 100 },
      { id: 'vision2', label: 'Vision Model 2', x: 500, y: 200 },
      { id: 'vision3', label: 'Vision Model 3', x: 500, y: 300 },
      { id: 'streaming', label: 'Streaming Data Store', x: 700, y: 200 },
    ];

    const links = [
      { source: 'camera1', target: 'collector' },
      { source: 'camera2', target: 'collector' },
      { source: 'camera3', target: 'collector' },
      { source: 'collector', target: 'vision1' },
      { source: 'collector', target: 'vision2' },
      { source: 'collector', target: 'vision3' },
      { source: 'vision1', target: 'streaming' },
      { source: 'vision2', target: 'streaming' },
      { source: 'vision3', target: 'streaming' },
    ];

    const svg = d3.select(svgRef.current)
      .attr('width', width)
      .attr('height', height);

    svg.selectAll('*').remove();

    // Draw links
    svg.selectAll('line')
      .data(links)
      .enter()
      .append('line')
      .attr('x1', (d) => nodes.find((node) => node.id === d.source).x)
      .attr('y1', (d) => nodes.find((node) => node.id === d.source).y)
      .attr('x2', (d) => nodes.find((node) => node.id === d.target).x)
      .attr('y2', (d) => nodes.find((node) => node.id === d.target).y)
      .attr('stroke', '#999')
      .attr('stroke-width', 2);

    // Draw nodes
    const nodeGroup = svg.selectAll('g')
      .data(nodes)
      .enter()
      .append('g')
      .attr('transform', (d) => `translate(${d.x}, ${d.y})`);

    nodeGroup.append('rect')
      .attr('width', 100)
      .attr('height', 40)
      .attr('x', -50)
      .attr('y', -20)
      .attr('fill', '#f3f4f6')
      .attr('stroke', '#666')
      .attr('rx', 5);

    nodeGroup.append('text')
      .text((d) => d.label)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'central')
      .attr('y', 5)
      .attr('font-size', '12px');

    // Add animated dot
    const dot = svg.append('circle')
      .attr('r', 5)
      .attr('fill', 'red')
      .attr('cx', nodes[0].x)
      .attr('cy', nodes[0].y);

    const pathData = links.map(link => {
      const sourceNode = nodes.find(node => node.id === link.source);
      const targetNode = nodes.find(node => node.id === link.target);
      return { x1: sourceNode.x, y1: sourceNode.y, x2: targetNode.x, y2: targetNode.y };
    });

    let index = 0;

    function moveDot() {
      const { x1, y1, x2, y2 } = pathData[index];
      dot.transition()
        .duration(1000)
        .attr('cx', x2)
        .attr('cy', y2)
        .on('end', () => {
          index = (index + 1) % pathData.length;
          moveDot();
        });
    }

    moveDot();
  }, []);

  return (
    <div>
      <button onClick={() => navigate(-1)} style={{ marginBottom: '10px', padding: '5px 10px', cursor: 'pointer' }}>Go Back</button>
      <svg ref={svgRef} />
    </div>
  );
};

export default FlowChartPage;
